import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-stone-100 px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjzkxa465ib9">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pj6b209wycow">
        <h2 className="text-center text-[1.6rem] font-black leading-tight tracking-tight text-stone-900 sm:text-[2.2rem]" data-id="element-19" data-mp="avlbggc8yvlq">
          <span aria-hidden="true" data-id="element-20" data-mp="ft4ppg8y38do">🎁 </span>5 Included Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-stone-600" data-id="element-21" data-mp="1tvl7du3q2pj">
          All five are{' '}
          <span className="font-bold text-red-500" data-id="element-22" data-mp="5vqmiic18g3b">included</span> with your
          $27 kit.
        </p>

        <ol className="mt-9 space-y-4" data-id="element-23" data-mp="3o24wk676k5wf">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm" data-id="element-24" data-mp="3o3y6bud3b68n" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-500 text-sm font-bold text-white" data-id="element-25" data-mp="1ma8lexoxcy26">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`${bonus.title} — 3D box mockup`} loading="lazy" width="1122" height="1402" className="h-28 w-[84px] shrink-0 object-contain sm:h-36 sm:w-28" data-id="element-26" data-mp="1r6z1vm4n5vo4" />
              <div data-id="element-27" data-mp="3df3chvtlhtn6">
                <h3 className="text-sm font-bold leading-snug text-stone-900 sm:text-base" data-id="element-28" data-mp="3ddiokp1sd8ya">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold text-red-500" data-id="element-29" data-mp="3n67r2ufczchh">
                  Included
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}